module.exports = __webpack_public_path__ + "static/img/photoFrame_bg.f644be6f.png";